const modal = "_aramrkfqwf";
const heading = "_arah1me8p4u";
const content = "_arac1pcacnb";

export { content, heading, modal };
import "./shared.modals.style.linaria.module.css";
//# sourceMappingURL=shared.modals.style.js.map
